import { Button, Modal } from "antd";
import type { components } from "../../helper";
import { formatDate } from "../../helper/method";

export default function ViewDetailContactUsInformation({
  onClose,
  open,
  isPending,
  data,
}: {
  open: boolean;
  onClose: () => void;
  isPending: boolean;
  data?: components["schemas"]["SiteContactUsDetailItem"];
}) {
  return (
    <Modal
      open={open}
      closeIcon={false}
      loading={isPending}
      onCancel={onClose}
      classNames={{
        footer: "hidden!",
        header: "hidden!",
        body: "px-4! flex! flex-col! gap-6!",
      }}
    >
      <div className="w-full items-start flex flex-col gap-8">
        <div className="flex flex-col gap-2 items-start">
          <span className="display-24-semi-bold text-right">
            جزئیات درخواست
          </span>
          <div className="flex flex-col gap-2 items-start mt-4">
            <span className="text-18-regular text-grayscale-600">
              {" "}
              شماره تلفن :{" "}
              <strong className="text-grayscale-950">
                {data?.phone_number}
              </strong>
            </span>
            <span className="text-18-regular text-grayscale-600">
              نام : <strong className="text-grayscale-950">{data?.name}</strong>
            </span>
            <span className="text-18-regular text-grayscale-600">
              موضوع :{" "}
              <strong className="text-grayscale-950">{data?.subject}</strong>
            </span>
            <span className="text-18-regular text-grayscale-600">
              ایمیل :{" "}
              <strong className="text-grayscale-950">{data?.email}</strong>
            </span>
            <span className="text-18-regular text-grayscale-600">
              تاریخ :{" "}
              <strong className="text-grayscale-950">
                {formatDate(data?.created ?? "")}
              </strong>
            </span>
            <span className="text-18-regular text-grayscale-600">
              توضیحات :
              <p className="text-grayscale-950"> {data?.description}</p>
            </span>
          </div>
        </div>
      </div>
      <div className="w-full flex gap-2">
        <Button onClick={onClose} type="primary">
          بستن
        </Button>
      </div>
    </Modal>
  );
}
